import React from 'react';
export const HeaderContext = React.createContext({
    columns: [],
    height: 0,
    hasStickyRightColumn: false,
});
//# sourceMappingURL=HeaderContext.js.map